import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Cabins } from '../components/Cabins';
import { Services } from '../components/Services';
import { Activities } from '../components/Activities';
import { Environment } from '../components/Environment';
import { DroneVideo } from '../components/DroneVideo';
import { Reviews } from '../components/Reviews';
import { Location } from '../components/Location';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-cream" data-id="element-319" data-mp="29fc009tud9q3">
      <Navbar data-id="element-320" data-mp="29ihp3p2h0blt" />
      <main data-id="element-321" data-mp="2dhgsh58k00b5">
        <Hero data-id="element-322" data-mp="2di8eppg9glor" />
        <About data-id="element-323" data-mp="2dirsqv2sipxi" />
        <Cabins data-id="element-324" data-mp="2dja0anuwkqkq" />
        <DroneVideo data-id="element-325" data-mp="2dfm41gy2pq2b" />
        <Services data-id="element-326" data-mp="3kvadqqzysjxn" />
        <Activities data-id="element-327" data-mp="3kvtmbh3q5vz0" />
        <Environment data-id="element-328" data-mp="3ku8u3y4vup4b" />
        <Reviews data-id="element-329" data-mp="3kv0nr3ex6cry" />
        <Location data-id="element-330" data-mp="3kxmsywec8g70" />
        <Contact data-id="element-331" data-mp="3owlx4es8w8xe" />
      </main>
      <Footer data-id="element-332" data-mp="3ovudm2bxa1nh" />
    </div>;
}